import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'timezoneDate',
})
export class TimezoneDatePipe implements PipeTransform {
  transform(value: string, format: string = 'DD/MM/YYYY HH:mm'): string {
    if (!value) return '';

    // Intentar extraer: fecha + zona horaria (nombre)
    const match = value.match(/^(.+?)\s+([A-Za-z_\/]+)\s+\([^)]+\)$/);
    if (!match) return moment(value).format(format); // fallback

    const [_, datePart, timezone] = match;

    return moment.tz(datePart, timezone).format(format);
  }
}
